<template>
    <base-link class="link--icon" v-bind="$attrs" v-on="$listeners">
        <slot></slot>
        <svg v-svg
             v-if="icon"
             :symbol="icon"
             :size="size"
             class="icon"
             role="presentation"
        />
    </base-link>
</template>
<script>
import BaseLink from '../base/base_link';
export default {
  components: {
    'base-link': BaseLink,
  },
  props: {
    icon: {
      type: String,
    },
    size: {
      type: String,
    },
  },
};
</script>
